import { Col, Descriptions, Row, Table } from "antd";
import { useContext, useEffect, useState } from "react";
import Axios from "axios";
import DashboardContext from "../../../../Context";

export default function Introducers({ isCustomer = false }) {
  const { urldashboard, authentication, handelerrors, handelloding, idview } =
    useContext(DashboardContext);
  const [info, setInfo] = useState({});
  const [tableDataWorker, setTableDataWorker] = useState([]);
  const [tableDataCustomer, setTableDataCustomer] = useState([]);

  useEffect(() => {
    getData();
    getIntroducedWorkers();
    getIntroducedCustomer();
  }, []);

  const getData = async () => {
    const id = JSON.parse(sessionStorage.getItem("workerId"))
      ? JSON.parse(sessionStorage.getItem("workerId"))
      : JSON.parse(sessionStorage.getItem("customerid"))
      ? JSON.parse(sessionStorage.getItem("customerid"))
      : idview;

    try {
      const res = await Axios.get(
        `${urldashboard}/worker/getIntroducer/${id}`,
        {
          headers: {
            Authorization: authentication,
            "Content-Type": "application/json",
          },
        }
      );

      const data = await res.data.data;
      setInfo(data);
      handelloding(false);
    } catch (error) {
      handelerrors(error);
    }
  };

  const getIntroducedWorkers = async () => {
    const id = JSON.parse(sessionStorage.getItem("workerId"))
      ? JSON.parse(sessionStorage.getItem("workerId"))
      : JSON.parse(sessionStorage.getItem("customerid"))
      ? JSON.parse(sessionStorage.getItem("customerid"))
      : idview;

    try {
      const res = await Axios.get(
        `${urldashboard}/worker/getWorkerIntroduced/${id}`,
        {
          headers: {
            Authorization: authentication,
            "Content-Type": "application/json",
          },
        }
      );

      const data = await res.data.data;
      setTableDataWorker(data);
      handelloding(false);
    } catch (error) {
      handelerrors(error);
    }
  };

  const getIntroducedCustomer = async () => {
    const id = JSON.parse(sessionStorage.getItem("workerId"))
      ? JSON.parse(sessionStorage.getItem("workerId"))
      : JSON.parse(sessionStorage.getItem("customerid"))
      ? JSON.parse(sessionStorage.getItem("customerid"))
      : idview;

    try {
      const res = await Axios.get(
        `${urldashboard}/worker/getCustomerIntroduced/${id}`,
        {
          headers: {
            Authorization: authentication,
            "Content-Type": "application/json",
          },
        }
      );

      const data = await res.data.data;
      setTableDataCustomer(data);
      handelloding(false);
    } catch (error) {
      handelerrors(error);
    }
  };

  const introducedColumns = [
    {
      title: "نام",
      dataIndex: "fullName",
      align: "center",
      render: (value) => <span>{value ?? "-"}</span>,
    },
    {
      title: "شماره همراه",
      dataIndex: "phoneNumber",
      align: "center",
      render: (value) => <span>{value ?? "-"}</span>,
    },
  ];

  return (
    <>
      <Row gutter={[30, 30]}>
        {info && (
          <Col span={24}>
            <Descriptions
              bordered
              column={2}
              size={"small"}
              title='اطلاعات معرف'
            >
              <Descriptions.Item label='نام معرف'>
                {info?.fullName ?? "اطلاعات وارد نشده"}
              </Descriptions.Item>
              <Descriptions.Item label='شماره همراه'>
                {info?.phoneNumber ?? "اطلاعات وارد نشده"}
              </Descriptions.Item>
              <Descriptions.Item label='جمع امتیاز'>
                {info?.totalScore ?? "اطلاعات وارد نشده"}
              </Descriptions.Item>
              <Descriptions.Item label='جمع کارها'>
                {info?.totalWorks ?? "اطلاعات وارد نشده"}
              </Descriptions.Item>
            </Descriptions>
          </Col>
        )}
        <Col span={24}>
          <Table
            bordered
            footer={null}
            columns={introducedColumns}
            dataSource={tableDataWorker}
            pagination={false}
            // loading={isLoading}
            title={() => "اطلاعات نیروهای معرفی شونده"}
          />
        </Col>
        <Col span={24}>
          <Table
            bordered
            footer={null}
            columns={introducedColumns}
            dataSource={tableDataCustomer}
            pagination={false}
            // loading={isLoading}
            title={() => "اطلاعات مشتری‌های معرفی شونده"}
          />
        </Col>
      </Row>
    </>
  );
}
